export default __webpack_public_path__ + "static/media/frame-4.013916e3.png";